/* eslint-disable no-prototype-builtins */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'
import behaviors from '../../../util/behaviors'
import Lurker from '../../../util/lurker'
import Subtitle from '../../atoms/Subtitle'
import { GenericErrorBox } from '../../molecules/GenericErrorBox'
import { sendPinCode } from '../../../api/scoreValidationApiCall'

import EmailFormBaseTemplate from '../EmailFormBaseTemplate'

const lurker = new Lurker('score_pincode')

const ErrorMsgWrapper = styled(View)`
  margin-top: 16px;
  margin-right: 0;
  margin-left: 0;
`

const Description = styled(Subtitle)`
  padding-top: 16px;
`

const errors = {
  showGenericError: false,
  showRateLimitError: false,
}

const renderDescription = () => (
  <React.Fragment>
    <Description>Precisamos confirmar que este e-mail é seu.</Description>
    <Subtitle>Enviaremos um código para</Subtitle>
  </React.Fragment>
)

class ScorePinCodeTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ...errors,
      email: props.email,
    }
  }

  componentDidMount() {
    const { flow } = this.props
    lurker.pageLoadEvt('score_pincode', { flow })
  }

  onSendPinCodeError = (error = {}) => {
    const { response: { status, data: { message } = {} } = {} } = error
    const { flow } = this.props
    const genericError = 'showGenericError'
    if (status === 401) {
      lurker.viewMessageEvt('error', {
        accounts_reason: 'unauthorized',
        accounts_status_code: status,
        context: flow,
      })
      this.showError(genericError)
    } else if (status === 429) {
      lurker.viewMessageEvt('error', {
        accounts_reason: 'rate_limit_exceeded',
        accounts_status_code: status,
        context: flow,
      })
      this.showError('showRateLimitError')
    } else if (status === 403) {
      if (message === 'ACCOUNT_LOCKED') {
        lurker.viewMessageEvt('error', {
          accounts_reason: message.toLowerCase(),
          accounts_status_code: status,
          context: flow,
        })
        this.showError('showRateLimitError')
      } else {
        lurker.viewMessageEvt('error', {
          accounts_reason:
            message && typeof message === 'string' ? message.toLowerCase() : 'unexpected_message',
          accounts_status_code: status,
          context: flow,
        })
        this.showError(genericError)
      }
    } else if (status) {
      lurker.viewMessageEvt('error', {
        accounts_reason: 'unexpected_status_code',
        accounts_status_code: status,
        context: flow,
      })
      this.showError(genericError)
    } else {
      lurker.viewMessageEvt('error', {
        accounts_reason: 'unexpected_error',
        accounts_error_message: (error && error.message) || 'unknown',
        context: flow,
      })
      this.showError(genericError)
    }
    behaviors.scrollToTop()
  }

  onSendPinCodeSuccess = data => {
    lurker.viewMessageEvt('success', {
      accounts_method: 'send_pincode',
      remote_addr: data.remoteAddress,
      context: this.props.flow,
    })
    if (this.props.onSuccess) {
      this.setState({
        showGenericError: false,
        showRateLimitError: false,
      })
      this.props.onSuccess(data)
    }
  }

  onSendPinCode = () => {
    const { token } = this.props
    sendPinCode(token).then(this.onSendPinCodeSuccess).catch(this.onSendPinCodeError)
  }

  handleSubmit = () => {
    this.setState({ ...errors }, () => this.onSendPinCode())
  }

  showError(error, extra) {
    this.setState({
      ...errors,
      ...extra,
      [error]: true,
    })
  }

  renderError = () => {
    const { showGenericError, showRateLimitError } = this.state
    return (
      <React.Fragment>
        {showGenericError && (
          <ErrorMsgWrapper>
            <GenericErrorBox text="Não foi possível enviar o código." />
          </ErrorMsgWrapper>
        )}
        {showRateLimitError && (
          <ErrorMsgWrapper>
            <GenericErrorBox
              showContactUs={false}
              text="Você excedeu o número de tentativas. Por favor, tente novamente mais tarde."
            />
          </ErrorMsgWrapper>
        )}
      </React.Fragment>
    )
  }

  render() {
    const { isLocked, onSwitchEmail, flow } = this.props
    const { email } = this.state

    return (
      <EmailFormBaseTemplate
        buttonText="Enviar código"
        editable={false}
        email={email}
        errorPosition="top"
        isLocked={isLocked}
        lurker={lurker}
        onSubmit={this.handleSubmit}
        onSwitchEmail={onSwitchEmail}
        renderError={this.renderError}
        renderTitle={renderDescription}
        submitEventName="send_pincode"
        useRecaptcha={false}
      />
    )
  }
}

ScorePinCodeTemplate.default = {
  isLocked: false,
}

ScorePinCodeTemplate.propTypes = {
  token: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  flow: PropTypes.string,
  onSuccess: PropTypes.func,
  onSwitchEmail: PropTypes.func,
  isLocked: PropTypes.bool,
}

export default ScorePinCodeTemplate
